import { t } from "i18next";

export function calculateAge(birthday) {
    // birthday is a date

    if (!(birthday instanceof Date)) {
        birthday = new Date(birthday);
    }

    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export function calculateTotalFinancialAssets(kyc) {
    return +kyc.deposits + +kyc.securities;
}

export function calculateTotalInvestmentAssets(kyc) {
    return (
        +kyc.securities +
        +kyc.registeredAccountsRESPAndTFSA +
        +kyc.RegisteredAccountsRESPs +
        +kyc.investmentAssetsOther
    );
}

export function calculateTotalOtherAssets(kyc) {
    return (
        +kyc.principalResidenceEquity +
        +kyc.otherRealEstateEquity +
        +kyc.otherAssetsVehicles +
        +kyc.collectablesArtValuables +
        +kyc.otherAssets
    );
}

export function calculateApproximateNetWorth(prevKyc) {
    return (
        +prevKyc.cashAndLiquid +
        calculateTotalInvestmentAssets(prevKyc) +
        calculateTotalOtherAssets(prevKyc) -
        +prevKyc.liabilities
    );
}

export function calculateAgeOfYoungestBeneficiary(beneficiary, kyc) {
    if (!kyc.ageOfYoungestBeneficiaryDefault) {
        return kyc.ageOfYoungestBeneficiary; // when its not default its set by user
    } else {
        return calculateAge(beneficiary.birthdate);
    }
}

export function calculateTimeHorizon(beneficiary, kyc) {
    let ageOfYoungestBeni = calculateAgeOfYoungestBeneficiary(beneficiary, kyc);

    if (ageOfYoungestBeni <= 3) {
        return t("15 years or more");
    } else if (ageOfYoungestBeni <= 8) {
        return t("10-14 years");
    } else if (ageOfYoungestBeni <= 13) {
        return t("5-9 years");
    } else {
        return t("Less than 5"); // TODO maybe change language?
    }
}

export function isMaternityForm(kyc) {
    return kyc.kycFormType == 1;
}

export function calculateMaxEducationSavingsPlans(
    subscriber,
    jointSubscriber,
    kyc,
) {
    let maternityForm = isMaternityForm(kyc);
    let monthlyDisposableIncomeTotal =
        calculateMonthlyIncomeNet(subscriber, jointSubscriber, kyc) -
        calculateTotalMonthlyExpenses(kyc);
    let monthlyDisposableIncomeTotalAfterMat =
        calculateMonthlyIncomeNetAfterMat(subscriber, jointSubscriber, kyc) -
        calculateTotalMonthlyExpensesAfterMat(kyc);
    let monthlyIncomeGrossTotal =
        +subscriber.monthlyIncomeGross +
        +jointSubscriber.monthlyIncomeGross +
        +kyc.otherMonthlyIncomeGross;
    let monthlyIncomeGrossTotalAfterMat =
        +subscriber.monthlyIncomeGrossAfterMat +
        +jointSubscriber.monthlyIncomeGrossAfterMat +
        +kyc.otherMonthlyIncomeGrossAfterMat;

    let maxEspBasedOnDisposableIncome =
        (monthlyDisposableIncomeTotal - +kyc.otherContractualObligations) * 0.6;

    let maxEspBasedOnDisposableIncomeAfterMat =
        (monthlyDisposableIncomeTotalAfterMat -
            +kyc.otherContractualObligationsAfterMat) *
        0.6;

    let maxEspBasedOnDisposableIncomeGroup =
        (monthlyDisposableIncomeTotal - +kyc.otherContractualObligations) * 0.5;

    let maxEspBasedOnDisposableIncomeGroupAfterMat =
        (monthlyDisposableIncomeTotalAfterMat -
            +kyc.otherContractualObligationsAfterMat) *
        0.5;

    let maxEspBasedOnDsr =
        monthlyIncomeGrossTotal * 0.5 -
        (+kyc.paymentOnLoansAndDebts +
            +kyc.morgageCondoFeesRent +
            +kyc.otherContractualObligations);

    let maxEspBasedOnDsrGroup =
        monthlyIncomeGrossTotal * 0.4 -
        (+kyc.paymentOnLoansAndDebts +
            +kyc.morgageCondoFeesRent +
            +kyc.otherContractualObligations);

    let maxEspBasedOnDsrAfterMat =
        monthlyIncomeGrossTotalAfterMat * 0.5 -
        (+kyc.paymentOnLoansAndDebtsAfterMat +
            +kyc.morgageCondoFeesRentAfterMat +
            +kyc.otherContractualObligationsAfterMat);

    let maxEspBasedOnDsrGroupAfterMat =
        monthlyIncomeGrossTotalAfterMat * 0.4 -
        (+kyc.paymentOnLoansAndDebtsAfterMat +
            +kyc.morgageCondoFeesRentAfterMat +
            +kyc.otherContractualObligationsAfterMat);

    let monthlySavings;

    if (maternityForm) {
        let returnToWorkDate = new Date(kyc.returnToWorkDate);
        if (returnToWorkDate) {
            console.log("returnToWorkDate", returnToWorkDate);
            let dt1 = new Date();
            let dt2 = returnToWorkDate;
            let diffTime = Math.abs(dt2 - dt1);
            let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let months = Math.ceil(diffDays / 30);
            let savings = +kyc.availableSavingsForRespContributions;
            monthlySavings = Math.floor(savings / months);

            console.log("monthlySavings", monthlySavings);
        } else {
            monthlySavings = 0;
        }
    } else {
        monthlySavings = 0;
    }

    maxEspBasedOnDisposableIncome += monthlySavings;
    maxEspBasedOnDisposableIncomeGroup += monthlySavings;
    maxEspBasedOnDsr += monthlySavings;
    maxEspBasedOnDsrGroup += monthlySavings;

    let lowest, lowestGroup;

    let monthlyMaximumEducationSavingsPlan;
    let monthlyMaximumEducationSavingsPlanGroup;

    if (maternityForm) {
        lowest = maxEspBasedOnDisposableIncomeAfterMat;
        if (lowest > maxEspBasedOnDsrAfterMat) {
            lowest = maxEspBasedOnDsrAfterMat;
        }
        lowestGroup = maxEspBasedOnDisposableIncomeGroupAfterMat;
        if (lowestGroup > maxEspBasedOnDsrGroupAfterMat) {
            lowestGroup = maxEspBasedOnDsrGroupAfterMat;
        }

        if (lowest > maxEspBasedOnDisposableIncome) {
            lowest = maxEspBasedOnDisposableIncome;
        }
        if (lowestGroup > maxEspBasedOnDisposableIncomeGroup) {
            lowestGroup = maxEspBasedOnDisposableIncomeGroup;
        }

        if (lowest > maxEspBasedOnDsr) {
            lowest = maxEspBasedOnDsr;
        }
        if (lowestGroup > maxEspBasedOnDsrGroup) {
            lowestGroup = maxEspBasedOnDsrGroup;
        }

        monthlyMaximumEducationSavingsPlan = lowest;
        monthlyMaximumEducationSavingsPlanGroup = lowestGroup;
    } else {
        if (maxEspBasedOnDisposableIncome < maxEspBasedOnDsr) {
            monthlyMaximumEducationSavingsPlan = maxEspBasedOnDisposableIncome;
        } else {
            monthlyMaximumEducationSavingsPlan = maxEspBasedOnDsr;
        }

        if (maxEspBasedOnDisposableIncomeGroup < maxEspBasedOnDsrGroup) {
            monthlyMaximumEducationSavingsPlanGroup =
                maxEspBasedOnDisposableIncomeGroup;
        } else {
            monthlyMaximumEducationSavingsPlanGroup = maxEspBasedOnDsrGroup;
        }
    }

    return {
        monthlyMaximumEducationSavingsPlan,
        monthlyMaximumEducationSavingsPlanGroup,
    };
}

export function monthlyAvailableSavingsForRespContributions(kyc) {
    let maternityForm = isMaternityForm(kyc);

    let monthlySavings;

    if (maternityForm) {
        let returnToWorkDate = new Date(kyc.returnToWorkDate);
        if (returnToWorkDate) {
            let dt1 = new Date();
            let dt2 = returnToWorkDate;
            let diffTime = Math.abs(dt2 - dt1);
            let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let months = Math.ceil(diffDays / 30);
            let savings = +kyc.availableSavingsForRespContributions;
            monthlySavings = Math.floor(savings / months);
        } else {
            monthlySavings = 0;
        }
    } else {
        monthlySavings = 0;
    }

    return monthlySavings;
}

export function calculateMonthlyIncomeNet(subscriber, jointSubscriber, kyc) {
    return (
        +subscriber.monthlyIncomeNet +
        +jointSubscriber.monthlyIncomeNet +
        +kyc.otherMonthlyIncomeNet
    );
}

export function calculateMonthlyIncomeNetAfterMat(
    subscriber,
    jointSubscriber,
    kyc,
) {
    return (
        +subscriber.monthlyIncomeNetAfterMat +
        +jointSubscriber.monthlyIncomeNetAfterMat +
        +kyc.otherMonthlyIncomeNetAfterMat
    );
}

export function calculateTotalMonthlyExpenses(kyc) {
    return (
        +kyc.paymentOnLoansAndDebts +
        +kyc.morgageCondoFeesRent +
        +kyc.groceries +
        +kyc.childCare +
        +kyc.clothing +
        +kyc.insurance +
        +kyc.utilities +
        +kyc.transportation +
        +kyc.miscellaneous
    );
}

export function calculateTotalMonthlyExpensesAfterMat(kyc) {
    return (
        +kyc.paymentOnLoansAndDebtsAfterMat +
        +kyc.morgageCondoFeesRentAfterMat +
        +kyc.groceriesAfterMat +
        +kyc.childCareAfterMat +
        +kyc.clothingAfterMat +
        +kyc.insuranceAfterMat +
        +kyc.utilitiesAfterMat +
        +kyc.transportationAfterMat +
        +kyc.miscellaneousAfterMat
    );
}

export function calculateMonthlyDisposableIncome(
    subscriber,
    jointSubscriber,
    kyc,
) {
    return (
        calculateMonthlyIncomeNet(subscriber, jointSubscriber, kyc) -
        calculateTotalMonthlyExpenses(kyc)
    );
}

export function calculateMonthlyDisposableIncomeAfterMat(
    subscriber,
    jointSubscriber,
    kyc,
) {
    return (
        calculateMonthlyIncomeNetAfterMat(subscriber, jointSubscriber, kyc) -
        calculateTotalMonthlyExpensesAfterMat(kyc)
    );
}

export function calculateMonthlyIncomeGross(subscriber, jointSubscriber, kyc) {
    return (
        +subscriber.monthlyIncomeGross +
        +jointSubscriber.monthlyIncomeGross +
        +kyc.otherMonthlyIncomeGross
    );
}

export function calculateMonthlyIncomeGrossAfterMat(
    subscriber,
    jointSubscriber,
    kyc,
) {
    return (
        +subscriber.monthlyIncomeGrossAfterMat +
        +jointSubscriber.monthlyIncomeGrossAfterMat +
        +kyc.otherMonthlyIncomeGrossAfterMat
    );
}

export function calculateYearlyIncomeGross(subscriber, jointSubscriber, kyc) {
    return calculateMonthlyIncomeGross(subscriber, jointSubscriber, kyc) * 12;
}

export function calculateYearlyIncomeGrossAfterMat(
    subscriber,
    jointSubscriber,
    kyc,
) {
    return (
        calculateMonthlyIncomeGrossAfterMat(subscriber, jointSubscriber, kyc) *
        12
    );
}

export function calculateYearlyIncomeNet(subscriber, jointSubscriber, kyc) {
    return calculateMonthlyIncomeNet(subscriber, jointSubscriber, kyc) * 12;
}

export function calculateDisposableIncomeAfterMat(
    subscriber,
    jointSubscriber,
    kyc,
) {
    return (
        calculateMonthlyIncomeNetAfterMat(subscriber, jointSubscriber, kyc) -
        calculateTotalMonthlyExpensesAfterMat(kyc)
    );
}

export function isDisposableIncomeExceeded(subscriber, jointSubscriber, kyc) {
    return (
        calculateMonthlyDisposableIncome(subscriber, jointSubscriber, kyc) <
            0 ||
        calculateMonthlyDisposableIncomeAfterMat(
            subscriber,
            jointSubscriber,
            kyc,
        ) < 0
    );
}

export function isEightyYearRuleExceeded(
    subscriber,
    jointSubscriber,
    kyc,
    common,
) {
    const subscriber2Include = common.subscriber2Include;

    const subscriber1Age = calculateAge(subscriber.birthdate);

    let subscriber2Age = 0;
    if (subscriber2Include) {
        subscriber2Age = calculateAge(jointSubscriber.birthdate);
    }

    if (subscriber1Age + 17 >= 80 || subscriber2Age + 17 >= 80) {
        return true;
    }
}

export function isKnowYourClientFormComplete(
    subscriber,
    jointSubscriber,
    kyc,
    common,
) {
    let isComplete = true;

    if (calculateApproximateNetWorth(kyc) == 0) {
        isComplete = false;
    }

    if (kyc.notes == "") {
        isComplete = false;
    }

    return isComplete;
}

/*
//Returns an empty string if an of the numbers in the list are not numbers
// Otherwise returns the sum of the numbers
export function add(listOfNumbers) {
    const ret = listOfNumbers.reduce((a, b) => +(a) + +(b), 0);
    return isNaN(ret) ? '' : ret;
}
*/

export const familyIncome = (state) => {
    return (
        (+state.subscriber.monthlyIncomeGross +
            +state.jointSubscriber.monthlyIncomeGross +
            +state.knowYourClient.otherMonthlyIncomeGross) *
        12
    );
};
